import React from 'react';
import { Center } from '@chakra-ui/react';
import { useTokens } from '../../../context/TokenProvider';
import NoResultsFoundIndicator from './NoResultsFoundIndicator';
const NoResultsFoundWrapper = (props) => {
    const tokens = useTokens();
    const style = {
        w: 'full',
        marginBottom: tokens.Spacing02,
        p: tokens.Spacing06,
    };
    return (React.createElement(Center, { sx: style },
        React.createElement(NoResultsFoundIndicator, { ...props })));
};
export default NoResultsFoundWrapper;
